<template lang="pug">
v-row(no-gutters)
  v-col.px-0(cols="3", sm="2")
    Avatar(
      :name="getContextNameLong(viewContext, creator)",
      :profile-url="creator.url",
      :image-url="creator.avatar_url",
      :clients="creator.clients",
      :variant="variant"
    )
  v-col(cols="9", sm="10")
    v-row(no-gutters)
      v-col(cols="10", sm="11")
        Subtitle(
          :text="getContextNameLong(viewContext, creator)",
          custom-class="mt-2 mb-0",
          style="cursor: pointer",
          :font-size="0.9",
          :font-weight="700",
          @click="goToProfile"
        )
        RelativeTime(:dateTime="createdAt")
      v-col.d-flex.justify-end(cols="2", sm="1")
        PopupMenu(:items="menuItems", v-if="menuItems.length")
    TextHTML(
      :html="text",
      :font-size="0.9",
      v-if="!isXsScreenSize && !isEdit",
      custom-class="mt-4"
    )
  TextHTML(
    :html="text",
    :font-size="0.9",
    v-if="isXsScreenSize && !isEdit",
    customClass="mt-2"
  )
</template>

<script lang="ts">
import Vue from "vue"
import TextHTML from "../UI/TextHTML.vue"
import Subtitle from "../UI/Subtitle.vue"
import RelativeTime from "../UI/RelativeTime.vue"
import Avatar from "../UI/Avatar.vue"
import { MenuItem } from "interfaces/menuItem.interface"
import PopupMenu from "../../app/ui-primitives/menus/popup-menu/PopupMenu.vue"
import { goToUrl } from "helpers/navigation"
import { GroupMember } from "suus-api"
import { PropType } from "vue"
import { getContextNameLong, ViewContext } from "concerns/useContextName"

export default Vue.extend({
  name: "CommentBlock",
  components: {
    Subtitle,
    RelativeTime,
    TextHTML,
    Avatar,
    PopupMenu,
  },
  props: {
    viewContext: { type: Object as PropType<ViewContext> },
    createdAt: { type: [String, Date], required: true },
    text: { type: String, required: true },
    creator: { type: Object as PropType<GroupMember>, required: true },
    menuItems: {
      type: Array as PropType<MenuItem[]>,
      default: () => [],
      required: true,
    },
    isEdit: { type: Boolean, default: false },
  },
  setup() {
    return { getContextNameLong }
  },
  computed: {
    isXsScreenSize(): boolean {
      return this.$vuetify.breakpoint.name === "xs"
    },
    variant(): "xs" | "sm" {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "xs"
        default:
          return "sm"
      }
    },
  },
  methods: {
    goToProfile() {
      if (this.creator.url) goToUrl(this.creator.url)
    },
  },
})
</script>
